import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AccessLevelProvider, UseAccessLevel } from "./AccessLevelContext";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import Sidebar from "./components/Sidebar";
import LoginForm from "./page/Login";
import PlantPage from "./page/Plant";
import Dashboard from "./page/Dashboard";
import BESS_Designer from "./page/BESS_Designer";
// import LicensesUpdate from "./page/LicensesUpdate";
import BigScreen from "./page/BigScreen";
import ForgotPassword from "./page/ForgotPassword";
import ResetConfirmation from "./page/ResetPassword";
import Test from "./page/Test";
import UserInfo from "./page/UserInfo";
import PasswordResetForm from "./page/ResetPasswordForm";
import { DarkModeProvider } from './components/DarkModeContext';
import AddSite from "./page/AddSite";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import SLD from './components/SLD';
import Map from './components/Map';
// import Testing from "./page/testing";
import DiagramEditor from "./components/DiagramEditor";
import DynamicDiagram from "./page/DynamicDiagram";
// import Chatbot from "./components/chatbot";
import { SIMManagementPage } from './page/SIMManagementPage';
import { PageTracker } from "./components/Pagetracker";
import AnalyticsDashboard from "./components/AnalyticsDashboard";

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = useState(false); // Manage sidebar state

  // Define routes where the Sidebar should not appear
  const excludedRoutes = ["/", "/Signup", "/ForgotPassword", "/reset-confirmation", "/BigScreen", "/reset-password/:token"];

  const sidebarRef = useRef(null);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setDrawerOpen(false); // Close the sidebar
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    // Validate the token on each route change
    const validateToken = () => {
      const accessToken = sessionStorage.getItem("accessToken");
      console.log("Your Access Token", accessToken)
      if (!accessToken) {
        console.log("No token found. Redirecting to login...");
        navigate("/");
        return;
      }

      // Add any additional validation logic here (e.g., expiry check)
    };

    validateToken();
  }, [location.pathname, navigate]); // Runs when the route changes



  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
      }}
    >
      {!excludedRoutes.includes(location.pathname) && (
        <Box
          sx={{
            width: drawerOpen ? "13%" : "4.3%",
            height: "100vh",
            position: "sticky",
            top: 0,
            flexShrink: 0,
          }}
        >
          <Sidebar
            isOpen={drawerOpen}
            open={() => setDrawerOpen(true)}
            onClose={() => setDrawerOpen(false)}
          />
        </Box>
      )}

      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
          width: excludedRoutes.includes(location.pathname) ? "100%" : drawerOpen ? "87%" : "95.7%",

        }}
      >
        {children}
      </Box>
      {/* <Chatbot /> */}
    </Box>


  );

};

// 👇 new — this component lives INSIDE AccessLevelProvider, so it can read userId from context
const AppContent = () => {
  const { userId } = UseAccessLevel();

  return (
    <>
      <PageTracker userId={userId} />
      <Routes>
        {/* Routes without Sidebar */}
        <Route path="/" element={<LoginForm />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/reset-confirmation" element={<ResetConfirmation />} />
        <Route path="/reset-password/:token" element={<PasswordResetForm />} />
        <Route path="/BigScreen" element={<BigScreen />} />
        <Route path="/SLD" element={<SLD />} />
        <Route path="/Map" element={<Map />} />
        {/* <Route path="/Testing" element={<Testing />} /> */}
        <Route path="/DiagramEditor" element={<DiagramEditor />} />

        {/* Routes with Sidebar */}
        <Route
          path="/PlantList"
          element={
            <Layout >
              <PlantPage />
            </Layout>
          }
        />
        <Route
          path="/Dashboard/:company_name"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/user-info"
          element={
            <Layout>
              <UserInfo />
            </Layout>
          }
        />
        <Route
          path="/test"
          element={
            <Layout>
              <Test />
            </Layout>
          }
        />
        <Route
          path="/AddSite"
          element={
            <Layout>
              <AddSite />
            </Layout>
          }
        />
        <Route
          path="/BESS_Designer"
          element={
            <Layout>
              <BESS_Designer />
            </Layout>
          }
        />
        {/* <Route
          path="/LicensesUpdate"
          element={
            <Layout>
              <LicensesUpdate />
            </Layout>
          }
        /> */}
        <Route
          path="/DynamicDiagram"
          element={
            <Layout>
              <DynamicDiagram />
            </Layout>
          }
        />
        <Route
          path="/SIMManagementPage"
          element={
            <Layout>
              <SIMManagementPage />
            </Layout>
          }
        />
        <Route
          path="/AnalyticsDashboard"
          element={
            <Layout>
              <AnalyticsDashboard />
            </Layout>
          }
        />
      </Routes>
    </>
  );
};


function App() {
  return (
    <>
      <Analytics />
      <SpeedInsights />
      <AccessLevelProvider>
        <DarkModeProvider>
          <Router>
            <AppContent /> {/* 👈 replaces the old inline <Routes> block */}
          </Router>
        </DarkModeProvider>
      </AccessLevelProvider>
    </>

  );
}

export default App;